import { useEffect, useRef } from "react";
import MemberTypePropertiesListItem from "./MemberTypePropertiesListItem";

const MemberTypePropertiesList = ({ member_type_properties }) => {
  const sortableRef = useRef(null);

  useEffect(() => {
    if (sortableRef.current) {
      $(sortableRef.current).sortable({
        connectWith: ".custom_form_fields_list",
        revert: 0,
        helper: "clone",
        start: (e, ui) => {
          $(ui.item).show();
        },
        stop: function (e, ui) {
          if (ui.item.parent().is(this)) $(this).sortable("cancel");
        },
      });
    }

    return () => {
      if (sortableRef.current) {
        $(sortableRef.current).sortable("destroy");
      }
    };
  }, []);

  return (
    <ul className="member_type_properties_list" ref={sortableRef}>
      {member_type_properties.map((memberTypeProperty) => (
        <MemberTypePropertiesListItem
          key={memberTypeProperty.id}
          member_type_property={memberTypeProperty}
        />
      ))}
    </ul>
  );
};

export default MemberTypePropertiesList;
